module.exports = __webpack_public_path__ + "img/pc.3cfb6de8.jpg";